import GoldAndSilverDetails from './GoldAndSilverDetails'

export default GoldAndSilverDetails
